import React, { useEffect, useState } from 'react';

import './styles.scss'
import { Carousel } from 'react-bootstrap';
import { getBanners } from '../../services/api-auto';

const Banner = ({ screen }) => {

  const [banner, setBanners] = useState([])

  const getListCampanhas = async() =>{
    const b = await getBanners()
    setBanners(b.data);
  }

  const typeBanner = screen === 'vitrine' ? '1' : '0'
  
  useEffect(() => {
    getListCampanhas()
  }, []);

  return (
    <div className="defaultBanner">
      <Carousel>
        {banner && banner.length > 0 && banner.filter(item => item.tipo == typeBanner).sort((a, b) => a.ordem > b.ordem ? 1 : -1).map((i) => (
          <Carousel.Item key={i.id}>
            <img className="destaqueDesktop"  src={`data:${i.imagemDestaqueDesktop?.contentType};base64,${i.imagemDestaqueDesktop?.fileContents}`} href={i.link} onClick={() => window.open(i.link)}/>
            <img className="destaqueMobile" src={`data:${i.imagemDestaqueMobile?.contentType};base64,${i.imagemDestaqueMobile?.fileContents}`} alt={i.link} onClick={() => window.open(i.link)}/>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}

export default Banner;
